module.exports = __webpack_public_path__ + "media/images/icons/tick-icon-9133c487ed585d8d0b3d2aff765232c9.svg";